<template>
    <div id="boxAtendimento">  
        <h3>Atendimento</h3>
        <input type="text" placeholder="Pesquisar em Atendimento" v-model="filtro" class="form-control"> <br />
        <div class="div-pai ">
          <div v-show="acessoBotoes" class="text-right right col-lg-1 botoeslaterais"> 
            <button type="button" class="btn btn-primary" title="Aguardando Atendimento" @click="aguardandoAtendimento" :disabled="habilitarBotoes"> 
              <i class="fa fa-child" aria-hidden="true" v-show="!loadAguardandoAtendimento"></i> 
              <i class="fa fa-circle-o-notch fa-spin" v-show="loadAguardandoAtendimento"></i> 
            </button> 
            <button type="button" class="btn btn-primary" title="Iniciar Atendimento" @click="fazerAtendimento" :disabled="habilitarBotoes"> 
              <i class="fa fa-user" aria-hidden="true" v-show="!loadAtendimento"></i> 
              <i class="fa fa-circle-o-notch fa-spin" v-show="loadAtendimento"></i>      
            </button> 
            <button type="button" class="btn btn-primary" title="Iniciar Atendimento Coletivo" @click="fazerAtendimentoColetivo" :disabled="habilitarBotoes"> 
              <i class="fa fa-users" aria-hidden="true" v-show="!loadColetivo"></i> 
              <i class="fa fa-circle-o-notch fa-spin" v-show="loadColetivo"></i>      
            </button> 
            <button type="button" class="btn btn-info" title="Encaminhar Exame Médico" @click="exameMedico" :disabled="habilitarBotoes"> 
              <i class="fa fa-medkit" aria-hidden="true" v-show="!loadMedico"></i> 
              <i class="fa fa-circle-o-notch fa-spin" v-show="loadMedico"></i>      
            </button> 
            <button type="button" class="btn btn-warning" title="Aguardando Retorno Candidato (Documentação Incompleta, Exame Complementar, etc)" @click="retornoCandidato" :disabled="habilitarBotoes"> 
              <i class="fa fa-retweet" aria-hidden="true" v-show="!loadRetornoCandidato"></i> 
              <i class="fa fa-circle-o-notch fa-spin" v-show="loadRetornoCandidato"></i> 
            </button> 
            <button type="button" class="btn btn-success" title="Finalizar Atendimento"  data-toggle="modal" data-target="#modalBaixaEstoque" :disabled="habilitarBotoes"> 
              <i class="fa fa-check-square-o" aria-hidden="true"></i> 
            </button>   
          </div> 
          <div class="divScroll col-lg-11">
            <ul class="list-group col-lg-12" >
              <li v-for="item of filteredData" class="list-group-item text-left"> 
              <span style="width: 275px;display: inline-block;"><strong>Hora Marcada:</strong><small> {{ item.DiaHorario.substr(11, 5) }} </small></span>
              <strong>Hora Atualização:</strong> <small> {{ item.DataAtualizacao != null ? item.DataAtualizacao.substr(11, 5) : '' }} </small><input style="float: right; width: 18px; height: 18px;" type="checkbox" title="Selecionar" v-model="selecionados" :value="item" />
              <br />
              <span style="width: 227px;display: inline-block;">
                <strong>Tipo: </strong>  
                <small v-if="item.TipoAtendimento == 0" class="label label-info"> Admissão </small>
                <small v-if="item.TipoAtendimento == 1" class="label label-danger"> Rescisão </small>
                <small v-if="item.TipoAtendimento == 2" class="label label-default"> Outros </small>
              </span>
              
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>Status: </strong> <small>{{ status(item.Status) }}</small>  
              <br/>
              <span style=" width: 275px;display: inline-block;"><strong>Nome: </strong> {{ item.Nome }}</span> 
              <span style=" width: 275px;display: inline-block;" v-if="item.Cpf"><strong>CPF: </strong> {{ item.Cpf }}</span> 
              <span style=" width: 275px;display: inline-block;" v-if="item.IdFichaAprovacao"><strong>Ficha Aprovação: </strong> <a target="_blank" :href="'http://fastrhluandre.com.br/FichaAprovacao/Visualizar/' + item.IdFichaAprovacao" > {{ item.IdFichaAprovacao }}</a></span> 
              <span v-if="item.RazaoSocial !== null">
                <br />
                <span><strong>Empresa: </strong>{{ item.RazaoSocial }}</span>
              </span>
              <br/>
              <strong> Obs.: </strong> <small>{{ item.Observacoes }}</small> 
              </li> 
            </ul> 
          </div> 
        </div>
        <div class="col-lg-12">
          <strong style="float:left;" v-if="this.items.length > 0">{{this.items.length}} pessoa(s) em atendimento. </strong>
          <strong style="float:left;" v-else>Não há ninguem  em atendimento.</strong>
        </div>
        <hr /> 
       <Finalizar :selecionados="selecionados" />  
        <modalAguardarRetorno :agendados="selecionados" idModal="modalAguardandoEmAtendimento"  />
    </div>
</template>
<script>
import Finalizar from './shared/atendimento/Finalizar.vue'
import modalAguardarRetorno from './shared/modal/AguardandoRetorno'
export default{
  name: 'EmAtendimento',
  components: {
    Finalizar,
    modalAguardarRetorno
  },
  computed: {
    habilitarBotoes () {
      return this.selecionados.length === 0
    },
    filteredData: function () {
      var filtro = this.filtro && this.filtro.toLowerCase()
      var data = this.items
      if (filtro) {
        data = data.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filtro) > -1
          })
        })
      }
      return data
    }
  },
  methods: {
    listar () {
      this.$http.get('exame-atendimento?dia=' + this.dia + '&unidade=' + parseInt(localStorage.getItem('Unidade')))
      .then(function (res) {
        this.items = res.body
        this.loadMedico = false
        this.loadColetivo = false
        this.loadAtendimento = false
        this.loadAguardandoAtendimento = false
        this.loadRetornoCandidato = false
      })
      .catch(function (err) {
        this.loadAtendimento = false
        console.log(err)
        this.loadMedico = false
        this.loadColetivo = false
        this.loadAtendimento = false
        this.loadAguardandoAtendimento = false
        this.loadRetornoCandidato = false
      })
    },
    fazerAtendimento () {
      if (this.selecionados.length === 0) {
        alert('Você deve selecionar ao menos uma pessoa')
        return false
      }
      this.loadAtendimento = true
      let agendamentovm = {
        agendamento: this.selecionados,
        Status: 1,
        IdUsuario: JSON.parse(localStorage.getItem('Usuario')).Usuario.Id
      }

      this.$http.put('atualizar-status', agendamentovm)
      .then(function (res) {
        this.listar()
        this.selecionados = []
      })
      .catch(function (err) {
        this.loadAtendimento = false
        alert('Ops! - Algo de errado aconteceu.\nEntre em contato com a área de Projetos.')
        console.log(err)
      })
    },
    aguardandoAtendimento () {
      if (this.selecionados.length === 0) {
        alert('Você deve selecionar ao menos uma pessoa')
        return false
      }
      this.loadAguardandoAtendimento = true
      let agendamentovm = {
        agendamento: this.selecionados,
        Status: 6,
        IdUsuario: JSON.parse(localStorage.getItem('Usuario')).Usuario.Id
      }
      this.$http.put('atualizar-status', agendamentovm)
      .then(function (res) {
        this.listar()
        this.selecionados = []
      })
      .catch(function (err) {
        this.loadAguardandoAtendimento = false
        alert('Ops! - Algo de errado aconteceu.\nEntre em contato com a área de Projetos.')
        console.log(err)
      })
    },
    fazerAtendimentoColetivo () {
      if (this.selecionados.length === 0) {
        alert('Você deve selecionar ao menos uma pessoa')
        return false
      }
      this.loadColetivo = true
      let agendamentovm = {
        agendamento: this.selecionados,
        Status: 2,
        coletivo: true,
        IdUsuario: JSON.parse(localStorage.getItem('Usuario')).Usuario.Id
      }

      this.$http.put('atualizar-status', agendamentovm)
      .then(function (res) {
        this.listar()
        this.selecionados = []
      })
      .catch(function (err) {
        this.loadColetivo = false
        alert('Ops! - Algo de errado aconteceu.\nEntre em contato com a área de Projetos.')
        console.log(err)
      })
    },
    retornoCandidato () {
      if (this.selecionados.length === 0) {
        alert('Você deve selecionar ao menos uma pessoa')
        return false
      }
      $('#modalAguardandoEmAtendimento').modal('show')
    },
    exameMedico () {
      if (this.selecionados.length === 0) {
        alert('Você deve selecionar ao menos uma pessoa')
        return false
      }
      this.loadMedico = true
      let agendamentovm = {
        agendamento: this.selecionados,
        Status: 4,
        IdUsuario: JSON.parse(localStorage.getItem('Usuario')).Usuario.Id
      }

      this.$http.put('atualizar-status', agendamentovm)
      .then(function (res) {
        this.listar()
        this.selecionados = []
      })
      .catch(function (err) {
        this.loadMedico = false
        alert('Ops! - Algo de errado aconteceu.\nEntre em contato com a área de Projetos.')
        console.log(err)
      })
    },
    status (id) {
      let escrito = ''
      switch (id) {
        case 0:
          escrito = 'Agendado'
          break
        case 1:
          escrito = 'Em Atendimento'
          break
        case 2:
          escrito = 'Em Atendimento Coletivo'
          break
        case 3:
          escrito = 'Finalizado'
          break
        case 4:
          escrito = 'Exame Médico'
          break
        case 5:
          escrito = 'Reagendar'
          break
        case 6:
          escrito = 'Aguardando'
          break
        case 7:
          escrito = 'Removido'
          break
        case 8:
          escrito = 'Aguardando Retorno Candidato'
          break
      }
      return escrito
    }
  },
  created: function () {
    this.listar()
  },
  props: ['data', 'filial', 'acessoBotoes'],
  data () {
    return {
      dia: this.data,
      filtro: '',
      items: [],
      selecionados: [],
      loadAtendimento: false,
      loadColetivo: false,
      loadMedico: false,
      loadAguardandoAtendimento: false,
      loadRetornoCandidato: false
    }
  }
}
</script>
<style scoped>
    #boxAtendimento{  
      width:100%;
      background: #fff;
    }
    #boxAtendimento h3{
      padding: 15px 0;
      background: #23527b;
      color:#fff;
    }
    #boxAtendimento thead td{
    padding: 8px 0;
    background: #2d618e;
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    }
    #boxAtendimento table td {
      border-color:#fff;
    }
    #boxAtendimento tfoot td{ 
    background: #cacaca;
    color: #fff; 
    }
  .div-pai{
      position: relative;    
      display: inline-block;
      width: 100%;
  }
    .divScroll{
      position: relative;
      height: 500px;
      max-height: 500px;
      overflow-y: scroll; 
    }
    .botoeslaterais{
      position: absolute;
      z-index: 2;
      height: 240px;
      right: 0px;
      top: 0;
      padding: 0;
    }
    .botoeslaterais button{
      display: inline-block;
      margin: 1px 0 0 0 ;
      width: 40px;
      height: 40px;
    }
</style>



// WEBPACK FOOTER //
// EmAtendimento.vue?a43b0a72